import type { LucideIcon } from 'lucide-react';
import type { AppRouteDefinition } from '@/app/route-registry';

export interface MobileNavItem {
  title: string;
  icon: LucideIcon;
  to: string;
  end: boolean;
}

/** Use the already access- and feature-filtered registry for phone tabs. */
export function createMobileNavigation(routes: readonly Pick<AppRouteDefinition, 'id' | 'path' | 'mobileTabs'>[]): MobileNavItem[] {
  const today = routes.find((route) => route.id === 'today');
  if (!today?.mobileTabs) return [];
  const destinations = new Set(routes.map((route) => route.id));
  const base = today.path.replace(/\/\*$/, '');
  return today.mobileTabs
    .filter((tab) => !tab.destinationId || destinations.has(tab.destinationId))
    .map((tab) => ({ title: tab.label, icon: tab.icon, to: base + tab.suffix, end: tab.suffix === '' }));
}
